<template>
  <span>
    <el-button @click="onClickShowDialog" size="small">
      상태 설정
    </el-button>
    <w-sliding-popup ref="slidingPopup" title="상태 설정" width="600px">
      <el-row slot="content">
        <el-row type="flex" justify="space-between" align="middle" class="vertical-center-box" style="margin-bottom: 8px">
          <div class="setting-addel">
            <el-button size="mini" @click="onClickAddL4Status"><i class="fas fa-plus"></i></el-button>
            <el-button size="mini" @click="onClickDeleteL4Status" :disabled="selectedRows.length < 1"><i class="fas fa-minus"></i></el-button>
          </div>
          <w-header-search-button @click="showSearchToolVirtual = !showSearchToolVirtual"></w-header-search-button>
        </el-row>
        <el-table-wrapper border :data="tableData" :columns="vitualColumns" :show-search-tool="showSearchToolVirtual" :show-custom-header="true" style="width:100%;"
          :pagination="false" :column-default="columnDefault" @selection-change="onSelectRow">
          <template slot-scope="scope" slot="check-slot">
            <el-checkbox v-model="scope.row.statusFaultFlag" true-label="Y" false-label="N" @change="onChangeCheckStatus"></el-checkbox>
          </template>
        </el-table-wrapper>
      </el-row>
      <el-row slot="footer" type="flex" justify="center">
        <el-button size="large" type="solid" class="mr-r4" @click="onClickSaveLfourSessionButton" :disabled="!checkSaveFlag">저장</el-button>
        <el-button size="large" @click="$refs.slidingPopup.close()">취소</el-button>
      </el-row>
    </w-sliding-popup>
    <w-lfour-session-add-sliding-popup ref="lfourSessionAddSlidingPopup" @reload-data="loadStore"></w-lfour-session-add-sliding-popup>
  </span>
</template>
<script>
import msgUtil from '@/utils/message';
import netdeviceTableInfoAPI from '@/api/performance/netdevice/netdevice-table-info';
import WLfourSessionAddSlidingPopup from '@/views/performance/node/analysis/netdevice/components/button/LfourSessionAddSlidingPopup';
import { cloneDeep, differenceWith, isEqual } from 'lodash';
import takeRightWhile from 'lodash/takeRightWhile';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { mapGetters } from 'vuex';

export default {
  name: 'WLfourSessionSettingsButton',
  components: {
    WLfourSessionAddSlidingPopup,
  },
  data() {
    return {
      targetObjCompanyId: null,
      tableData: [],
      tableDataOrigin: [],
      selectedRows: [],
      showSearchToolVirtual: false,
      messageTypeName: 'L4 세션 설정',
      columnDefault,
      checkSaveFlag: false,
      vitualColumns: [
        {
          type: 'selection',
        },
        {
          prop: 'statusValue',
          label: '상태명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'statusFaultFlag',
          label: '장애여부',
          sortable: true,
          align: 'center',
          scopedSlot: 'check-slot',
        },
      ],
      saveList: [],
    };
  },
  computed: mapGetters(['selectedNode']),
  methods: {
    /**
     * [loadStore L4 세션 설정 데이터를 뿌려준다.]
     * 선택한 관리대상의 objCompanyId를 보내주며 가상, 물리 서버 구분 없이 하나로 통합하여 보여주도록 한다. - (Song - 2020. 01. 02)
     *
     * @author {Yang} - {Song}
     * @return {[type]} [description]
     */
    loadStore() {
      this.checkSaveFlag = false; // init
      if (this.selectedNode && this.selectedNode.obj.objCompanyId) {
        netdeviceTableInfoAPI.getL4Settings(this.selectedNode.obj.objCompanyId).then((response) => {
          if (response.data.success === true) {
            this.tableData = response.data.data;
            this.tableDataOrigin = cloneDeep(response.data.data);
          }
        });
      } else {
        this.tableData = [];
      }
    },
    onClickShowDialog() {
      this.$refs.slidingPopup.open();
      this.loadStore();
    },
    /**
     * [onChangeSelectionCheckBox 변경된 데이터면 저장한다.]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onChangeSelectionCheckBox(row) {
      const removeVariable = takeRightWhile(this.saveList, {
        statusKey: row.statusKey,
        serverType: row.serverType,
        objCompanyOid: row.objCompanyOid,
        objCompanyId: row.objCompanyId,
        statusFaultFlag: row.statusFaultFlag,
      });
      if (removeVariable.length !== 0) {
        this.saveList.pop(removeVariable);
      } else {
        this.saveList.push(row);
      }
    },
    /**
     * [onClickSaveLfourSessionButton 저장버튼 클릭시 L4세션 설정 데이터를 저장한다.]
     * @author {Song}
     * @return {[type]} [description]
     */
    onClickSaveLfourSessionButton() {
      const targetFilteredData = differenceWith(this.tableData, this.tableDataOrigin, isEqual);
      netdeviceTableInfoAPI.updateL4Settings(targetFilteredData).then((res) => {
        if (res.data.success) {
          this.$refs.slidingPopup.close();
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, this.messageTypeName, true));
          this.$emit('reload-data');
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, this.messageTypeName, false));
        }
      })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, this.messageTypeName, false));
        });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [onClickAddL4Status L4 상태 추가] - 상태 추가용 새로운 팝업창을 하나 더 띄운다.
     * @author {Song}
     * @return {[type]} [description]
     */
    onClickAddL4Status() {
      const params = {
        objCompanyOid: this.tableData[0] ? this.tableData[0].objCompanyOid : null,
        objCompanyId: this.selectedNode.obj.objCompanyId,
      };
      this.$refs.lfourSessionAddSlidingPopup.open(params);
    },
    /**
     * [onClickDeleteL4Status L4 상태 삭제]
     * @author {Song}
     * @return {[type]} [description]
     */
    onClickDeleteL4Status() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        netdeviceTableInfoAPI.deleteLfourSessionStatusList(this.selectedRows).then((res) => {
          if (res.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, this.messageTypeName, true));
            this.loadStore();
            this.$emit('reload-data');
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, this.messageTypeName, false));
          }
        })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, this.messageTypeName, false));
          });
      });
    },
    onSelectRow(record) {
      this.selectedRows = record;
    },
    /**
     * [onChangeCheckStatus 변경감지]
     * @author {Song}
     * @return {[type]} [description]
     */
    onChangeCheckStatus() {
      this.checkSaveFlag = isEqual(this.tableData, this.tableDataOrigin) === false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/button/LfourSessionSettingsButton.vue